export default __webpack_public_path__ + "static/media/img1.60b72477.svg";